import { StrictMode, Suspense } from 'react';
import { Provider } from 'react-redux';
import { Loader } from './components/Loader';
import { DxfIntegrationContextProvider } from './context/dxfIntegrationContext';
import { LocalizationContextProvider } from './context/localizationContext';
import { PlatformContextProvider } from './context/platformContext';
import { RoutingContextProvider } from './context/routingContext';
import { useStyles } from './hooks/use-styles';
import { IndexPage } from './pages/index';
import store from './store/store';

export const App = () => {
  const styles = useStyles();

  return (
    <Provider store={store}>
      <PlatformContextProvider>
        <LocalizationContextProvider>
          <DxfIntegrationContextProvider>
            <RoutingContextProvider>
              <StrictMode>
                <Suspense fallback={<Loader />}>
                  {styles}
                  <main className="ebds">
                    <IndexPage />
                  </main>
                </Suspense>
              </StrictMode>
            </RoutingContextProvider>
          </DxfIntegrationContextProvider>
        </LocalizationContextProvider>
      </PlatformContextProvider>
    </Provider>
  );
};
